import cn from "classnames"
import { Fragment } from "react"

import { Flex, Popover } from "@/atoms"
import { KaiButton } from "@/molecules/KaiButton"

import styles from "./TitleDrawer.module.scss"

import type { TitleDrawerProps } from "."

export const TitleDrawer = (props: TitleDrawerProps) => {
  const {
    prefix,
    title,
    subTitle,
    aside,
    icon,
    loading,
    style,
    popover,
    noKaiButton,
    classes = {}
  } = props

  if (loading) {
    return <div className={cn(styles.loading)} />
  }

  const isLgSize = !!subTitle
  const classNameWithSubtitle = isLgSize && styles.withSubtitle
  const textSectionClassName = cn(styles.titleSection, classes.title)
  const Wrapper = popover ? Popover : Fragment
  const wrapperProps = popover
    ? ({ content: popover, trigger: "hover", placement: "bottomLeft" } as const)
    : {}

  return (
    <Flex className={styles.wrapper}>
      <Flex vertical flex={1}>
        {prefix}
        <Flex
          gap={8}
          align="center"
          style={style}
          className={cn(
            styles.container,
            classNameWithSubtitle,
            classes.container
          )}
        >
          {icon && (
            <span
              className={cn(styles.icon, classNameWithSubtitle, classes.icon)}
            >
              {icon}
            </span>
          )}
          <Wrapper {...wrapperProps}>
            <Flex vertical className={textSectionClassName}>
              {title}
              {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
            </Flex>
          </Wrapper>
        </Flex>
      </Flex>
      <Flex gap={12} justify="flex-end" className={classes.aside}>
        {aside}
        {!noKaiButton && <KaiButton size="small" />}
      </Flex>
    </Flex>
  )
}
